import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_TURN_TIME_STAGES_ACTION_TYPE } from '../actions/turnTimeStages.actions';

const initialState = null;

const turnTimeStagesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_TURN_TIME_STAGES_ACTION_TYPE.SET_TURN_TIME_STAGES:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default turnTimeStagesReducer;
